import '../../styles/theme.scss';
import 'flickity'; // Needed for react flickity component
import qs from 'qs';
import shave from 'shave';
import Headroom from 'headroom.js';
import Bowser from 'bowser';
import Cookies from 'js-cookie';
import { initKlaviyo } from '../utils/klaviyo';
import { initWishlist } from '../snippets/customer.wishlist';
import { initPreezieAddToCart } from '../snippets/preezieAddToCart';
import relatedProducts from '../snippets/relatedProducts';
import { handleHistoricalUrlParams } from '../utils/historical-url-params-helper';
import PageFly from '../utils/pagefly';
import popupModal from '../utils/popup';
import { removeFeatureFlag, setFeatureFlag } from '../utils/feature-flag';
import { initZendesk, initZendeskDefault } from '@jbhi-fi/utils/src/zendesk/zendesk';
import dynamicallyResizeShopifyImageUrl from '@jbhi-fi/utils/src/resizeShopifyImage/resizeShopifyImage';
import appendResults from '../templates/components/search-results/append-results';
import { handleLoginCreate, handleLogout } from '../utils/signInOutUp/AuthenticationHelper';

/* eslint-enable */
/* =============== Snippets ================= */
import '../utils/analytics';
import { Algolia } from '../utils/algolia';
import { trackLoginStart } from '../hooks/useLoginTracking/useLoginTracking';
import { removeLocal, LocalStorageKeys } from '@jbhi-fi/utils/src/localStorage';
import { trackPageView } from '@jbhi-fi/utils/src/ga360Tracking/functions/trackPageView';

import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';
import { transformShopifyProductForTracking } from '../utils/cart/transformShopifyProductForTracking';
import { trackAddToCart } from '@jbhi-fi/utils/src/ga4Tracking';
import { getStoreCurrency } from '../utils/shopify/getStoreCurrency';
import { initialiseCart, updateCart } from '../utils/cart/cartUtils';
import { initGetWishlist } from '../snippets/initGetWishlist';
import '../utils/appInsights';

window.handleLogout = handleLogout;
window.slate = window.slate || {};
window.theme = window.theme || {};
window.Jbhifi = window.Jbhifi || {};
window.localStorage.removeItem('cart-change-reloaded');
window.searchFooterDismissUser = false;
window.relatedProducts = relatedProducts;
window.setFeatureFlag = setFeatureFlag;
window.removeFeatureFlag = removeFeatureFlag;

window.Jbhifi.isProd = process.env.NODE_ENV === 'production';

/* eslint-enable */

// We want this to be available ASAP (for use on collection pages)
window.themeConfig('Algolia', Algolia);

// Detection for unsupported browsers
// As high as possible to be run as soon as possible
const browser = Bowser.getParser(window.navigator.userAgent);
const browserWarning = document.getElementById('BrowserWarning');
// Browser version definitions
// Browser names: https://github.com/lancedikson/bowser/blob/master/src/constants.js

const isUnsupportedBrowser = browser.satisfies({
  windows: {
    ie: '<11.0',
  },

  macos: {
    safari: '<=10.1',
  },

  mobile: {
    safari: '<=9',
    'android browser': '<3.10',
  },

  ie: '<11.0',
});

// Check if the cookie exists
const hasDismissCookie = Cookies.get('jb_hide_browser_warning');

if (browserWarning && !hasDismissCookie) {
  if (!isUnsupportedBrowser && browserWarning) {
    browserWarning.style.display = 'none';
  } else {
    browserWarning.style.display = 'block';
    const dismissButton = browserWarning.querySelector('.icon--close');
    if (dismissButton) {
      // If they dismiss the banner then set a cookie to hide it
      // Cookie expires in 24hrs (1 day)
      dismissButton.addEventListener('click', () => {
        Cookies.set('jb_hide_browser_warning', 'true', { expires: 1 });
        browserWarning.style.display = 'none';
      });
    }
  }
}

// Detect if user is on a touch device
window.isTouchDevice = false;
if ('ontouchstart' in document.documentElement) {
  window.isTouchDevice = true;
}

/* eslint-enable */
jQuery($ => {
  // Search forward-tracking
  window.addEventListener('popstate', () => {
    const state = document.readyState;
    if (
      (window.location.pathname === '/search' || window.location.pathname === '/search/') &&
      !document.querySelector('#search-results-container') &&
      state == 'complete'
    ) {
      const term = window.location.search ? qs.parse(window.location.search.slice(1)).query : null;
      appendResults({ term });
    }
  });

  let windowWidthValue = $(window).width();
  window.theme.windowWidthValue = windowWidthValue;

  // Page menu drawer
  $('.mobile-pagemenu-trigger').on('click', () => {
    $('body').toggleClass('page-open');
    $('.page-container-side').toggleClass('open');
  });
  // Collection menu drawer

  let drawerOpened = false;

  $('#collection-search-close a').on('click', event => {
    event.preventDefault();
    $('#collection-drawer').toggleClass('open');
    $('body').toggleClass('mobile-open');

    drawerOpened = !drawerOpened;
  });

  $('.mobile-aismenu-trigger.open').on('click', () => {
    $('#collection-drawer').addClass('open');
    $('body').addClass('mobile-open');
    drawerOpened = true;
  });
  $('.mobile-aismenu-trigger.close').on('click', () => {
    $('#collection-drawer').removeClass('open');
    $('body').removeClass('mobile-open');
    drawerOpened = false;
  });

  $('.mobile-menu-trigger.open').on('click', () => {
    $('body').addClass('mobile-open');
    $('.column-side').addClass('open');
    drawerOpened = true;
  });
  $('.mobile-menu-trigger.close').on('click', () => {
    $('body').removeClass('mobile-open');
    $('.column-side').removeClass('open');
    drawerOpened = false;
  });

  let windowWidth = $(window).width();
  let resizeTimer;
  window.theme.windowWidth = windowWidth;

  $(window).on('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if ($(window).width() !== windowWidth) {
        if ($(window).width() >= 1010 && windowWidth < 1010) {
          // Switched to desktop: hide drawer + overlay if opened
          if (drawerOpened) {
            $('body').removeClass('mobile-open');
          }
          if ($('.mobile-menu').hasClass('mobile-menu__close')) {
            $('body').removeClass('menu-open');
            $('.mobile-menu').removeClass('mobile-menu__close').addClass('mobile-menu__open');
            $('.main-menu-level1 > .mobile-trigger.is-open').each((index, element) => {
              const $mobileTrigger = $(element);
              // Update the chevrons and close other dropdowns
              $mobileTrigger.toggleClass('is-open');
              $mobileTrigger.parent().toggleClass('is-expanded');
              $mobileTrigger.next('.main-menu-dropdown').toggle().removeAttr('style');
            });
          }
          $('.main-menu-dropdown').removeAttr('style');
          $('.mobile-menu-column').removeAttr('style');
        } else if ($(window).width() < 1010 && windowWidth >= 1010) {
          // Switched to mobile: show drawer if opened
          if (drawerOpened) {
            $('#collection-drawer').addClass('open');
            $('body').addClass('mobile-open');
          }
        }
      }
      windowWidth = $(window).width();
      window.theme.windowWidth = windowWidth;
    }, 200);
  });

  // Search and Collection SEO read more/less
  const textHeight = $('.textbox-a .full').height();
  const $readmore = $('#readmore');

  if (textHeight > 50) {
    $('#readmore').show();
  } else {
    $('#readmore').hide();
  }

  window.addEventListener('resize', event => {
    if (event.target.innerWidth >= 750) {
      $('.textbox-a .full').show();
      $('.textbox-a .truncated').hide();
    } else if ($readmore.text() === 'Read more') {
      $('.textbox-a .full').hide();
      $('.textbox-a .truncated').show();
      $readmore.text('Read more').blur();
    } else {
      $('.textbox-a .truncated').hide();
      $('.textbox-a .full').show();
      $readmore.text('Read less').blur();
    }
  });

  $('#readmore').on('click touchend', event => {
    event.preventDefault();
    if ($readmore.text() === 'Read more') {
      $('.textbox-a .truncated').hide();
      $('.textbox-a .full').show();
      $readmore.text('Read less').blur();
    } else {
      $('.textbox-a .full').hide();
      $('.textbox-a .truncated').show();
      $readmore.text('Read more').blur();
    }
    $('.textbox-a div').toggleClass('heightAuto');

    return false;
  });

  //Login buttons
  Array.from(document.querySelectorAll('[data-login-btn]') ?? [])?.forEach(button =>
    button.addEventListener('click', event => {
      event.preventDefault();
      trackLoginStart({});
      handleLoginCreate(button.getAttribute('href'));
    })
  );

  // Apply a specific class to the html element for browser support of cookies.
  if (window.navigator.cookieEnabled) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }

  // Translate old url parameters
  handleHistoricalUrlParams();

  // Init mini cart
  // initMiniCart();

  // Init Klaviyo subscribe forms
  initKlaviyo();

  // execute rendering pageFly product tiles
  PageFly();

  initWishlist();
  initGetWishlist();

  popupModal();

  initPreezieAddToCart();

  trackPageView({
    isLoggedIn: window.Jbhifi?.customerDetails?.isLoggedIn,
    isPerks: window.Jbhifi?.customerDetails?.isPerks,
    coupon: window.Jbhifi?.coupons?.map(coupon => coupon.couponName).join(' | ') || '',
    couponId: window.Jbhifi?.coupons?.map(coupon => coupon.couponExternalId).join(' | ') || '',
    couponCount: window.Jbhifi?.coupons?.length,
  });

  // Init Zendesk Chat
  if (window.Jbhifi?.zendeskWidgetKey) {
    if (window.Jbhifi?.zendeskEnabled) {
      initZendesk();
    } else {
      initZendeskDefault();
    }
  }
});

(async () => {
  // Truncates text in SEO textbox A
  shave('.textbox-a .truncated', 60);
  await initialiseCart();
})(jQuery);

window.theme.dynamicallyResizeShopifyImageUrl = dynamicallyResizeShopifyImageUrl;

window.theme.productClick = (productsArray, sku, isSearch, isFeatured) => {
  let clickedProduct;

  for (const [index, product] of productsArray.entries()) {
    if (product.id === sku.toString()) {
      // Assign the gtm details to the product
      if (!product.position) {
        product.position = index + 1;
      }
      product.quantity = 1;
      if (window.title && isFeatured) {
        product.productsList = window.title.concat('-enhanced');
      } else if (product.list) {
        product.productsList = product.list;
      }
      clickedProduct = product;
      break;
    }
  }
  // Send the clicked product info off to GA
  if (clickedProduct) {
    if (clickedProduct.productsList) {
      window.gtm.track(
        'productClick',
        { products: [clickedProduct], productsList: clickedProduct.productsList },
        false,
        isSearch
      );
    } else {
      window.gtm.track('productClick', { products: [clickedProduct] }, false, isSearch);
    }
  }
};

// Click event on product tiles loaded shopify-side
$('a.product-tile').on('click', event => {
  event.stopPropagation();
  const sku = $(event.currentTarget).data('product-sku');
  if (window.gtm.featureProducts) {
    window.theme.productClick(window.gtm.featureProducts, sku, false, true);
  } else {
    if (
      window.homepageModules?.length &&
      window.gtm.products &&
      !window.gtm.products.some(prod => prod.id.toString() === sku.toString())
    ) {
      window.theme.productClick(window.homepageModules, sku, false, true);
    } else {
      window.theme.productClick(window.gtm.products, sku, false, true);
    }
  }
});

const updateCollectionRefinementElementPosition = () => {
  const customEvent = new CustomEvent('JB-header-nav-pin-change');
  window.dispatchEvent(customEvent);
};

// grab an element
const stickyHeader = document.querySelector('#shopify-section-header');
// construct an instance of Headroom, passing the element
const headroomOptions = {
  offset: document.getElementById('shopify-section-header').offsetHeight + 40,
  onUnpin: () => {
    updateCollectionRefinementElementPosition();
  },
  onPin: updateCollectionRefinementElementPosition,
};
const headroom = new Headroom(stickyHeader, headroomOptions);
window.headroom = headroom;

// Get the header container
const headerContainer = document.querySelector('#shopify-section-header');

// Get the footer container
const footerContainer = document.querySelector('#shopify-section-footer');

// Apply data-nosnippet's
headerContainer.setAttribute('data-nosnippet', '');
footerContainer.setAttribute('data-nosnippet', '');

// initialise
headroom.init();

// Preezie Add to Cart Event
const preezieAddToCartEvent = async event => {
  if (!event.detail) return;
  const variantId = event.detail[0].id;
  const storefrontClient = new ShopifyStorefrontClient();
  const { data } = await storefrontClient.getProductsByVariantId([variantId]);
  if (!data.products?.[0].metafields?.onlineProduct) return;
  const productData = data.products[0].metafields?.onlineProduct;
  const trackingData = {
    location: 'preezie-chat',
    currency: getStoreCurrency(),
    addedItems: { ...transformShopifyProductForTracking({ listName: 'preezie-chat', item: productData }) },
  };
  const updatedCart = await storefrontClient.getCart();
  await updateCart(updatedCart);
  trackAddToCart(updatedCart);
};
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('przGreenbackAddToCartEvent', preezieAddToCartEvent);
});
